<template>
  <nav-menu-category
    name="Greeting cards" fragment="greeting-cards"
    :icon="mdiCards"
    v-bind="$attrs" v-on="$listeners"
  />
</template>


<script>
import NavMenuCategory from '@/components/NavMenuCategory.vue';
import { mdiCards } from '@mdi/js';

export default {
  name: 'nav-menu-greeting-cards',
  components: { NavMenuCategory },
  created() {
    Object.assign(this, { mdiCards });
  }
}
</script>
